// src/components/Sidebar/SidebarTabs.js

import React, { useState } from 'react';
import SidebarNode from './SidebarNode';
import WorkflowItem from './WorkflowItem';

// Import icons
import checkForServiceIcon from '../Nodes/CheckForServiceNode/checkForServiceIcon.svg';
import addressServiceabilityIcon from '../Nodes/AddressServiceabilityNode/addressServiceabilityIcon.svg';
import chooseProductsIcon from '../Nodes/ChooseProductsNode/chooseProductsIcon.svg';
import paymentIcon from '../Nodes/PaymentNode/paymentIcon.svg';
import reviewCartIcon from '../Nodes/ReviewCartNode/reviewCartIcon.svg';
import jsonIcon from '../Nodes/SetValuesNode/jsonIcon.svg';
import emailIcon from '../Nodes/EmailNode/emailIcon.svg';
import crmIcon from '../Nodes/UpdateCrmNode/crmIcon.svg';
import selfSchedulingIcon from '../Nodes/SelfSchedulingNode/selfSchedulingIcon.svg';
import addOnsIcon from '../Nodes/AddOnsNode/addOns.svg';
import selectPlanIcon from '../Nodes/AddOnsNode/addOns.svg';
import accountSetupIcon from '../Nodes/AccountSetupNode/accountSetupIcon.svg';
import orderReceiptIcon from '../Nodes/OrderReceiptNode/orderReceiptIcon.svg';
import landingPageIcon from '../Nodes/LandingPageNode/landingPageIcon.svg';
import selfSerivceSignupIcon from '../../assets/icons/self_service_signup.svg';
import credentialsIcon from '../Nodes/CredentialsNode/credentialsIcon.svg';
import multiDwellingUnitIcon from '../../assets/icons/multi_dwelling_unit.svg';
import gardenWallIcon from '../../assets/icons/garden_wall.svg';

import cardIcon from '../../assets/icons/card.svg';
import portIcon from '../../assets/icons/port.svg';
import splitterIcon from '../../assets/icons/splitter.svg';
import virtualLayerIcon from '../../assets/icons/virtual-layer.svg';
import rackIcon from '../../assets/icons/rack.svg';

const SidebarTabs = ({ setActiveWorkflow, nodes }) => {
  // Receive the handler as a prop
  const [activeTab, setActiveTab] = useState('Widgets');
  // console.log(nodes);

  return (
    <div>
      {/* Tab Headers */}
      <div style={{ display: 'flex', marginBottom: '10px' }}>
        {/* <div
          style={{
            flex: 1,
            textAlign: 'center',
            padding: '10px',
            cursor: 'pointer',
            backgroundColor: activeTab === 'Workflows' ? '#fff' : '#e0e0e0',
            fontWeight: activeTab === 'Workflows' ? 'bold' : 'normal',
            color: activeTab === 'Workflows' ? '#333' : '#666',
            borderRadius: '8px 0 0 8px',
            transition: 'background-color 0.3s',
          }}
          onClick={() => setActiveTab('Workflows')}
        >
          Workflows
        </div> */}
        <div
          style={{
            flex: 1,
            textAlign: 'center',
            padding: '10px',
            cursor: 'pointer',
            backgroundColor: activeTab === 'Widgets' ? '#fff' : '#e0e0e0',
            fontWeight: activeTab === 'Widgets' ? 'bold' : 'normal',
            color: activeTab === 'Widgets' ? '#333' : '#666',
            borderRadius: '0 8px 8px 0',
            transition: 'background-color 0.3s',
          }}
          onClick={() => setActiveTab('Widgets')}
        >
          Widgets
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'Workflows' ? (
          <div>
            {/* Add onClick to change the workflow */}
            <div onClick={() => setActiveWorkflow('SelfServiceSignup')}>
              <WorkflowItem
                label="Self service signup"
                icon={selfSerivceSignupIcon}
                description="Enjoy instant account access with our self-service signup."
              />
            </div>
            <div onClick={() => setActiveWorkflow('MultiDwellingUnit')}>
              <WorkflowItem
                label="Multi-Dwelling Unit"
                icon={multiDwellingUnitIcon}
                description="Building containing multiple self-contained living spaces for separate households."
              />
            </div>
          </div>
        ) : (
          <div>
            <SidebarNode
              type="checkForServiceNode"
              label="Check for Service"
              icon={checkForServiceIcon}
              description="Check service availability at this location."
            />
            <SidebarNode
              type="chooseProductsNode"
              label="Choose Products"
              icon={chooseProductsIcon}
              description="Explore and select the products subscriber need."
            />
            {/* <SidebarNode
              type="serviceSelectionNode"
              label="Service Selection"
              icon={selectPlanIcon}
              description="Enable users to select plans."
            /> */}
            <SidebarNode
              type="addOnsNode"
              label="Add-Ons"
              icon={addOnsIcon}
              description="Enable users to select and customize additional services or products."
            />
            {<SidebarNode
              type="selfSchedulingNode"
              label="Self Scheduling"
              icon={selfSchedulingIcon}
              description="Schedule installation at subscribers convenience."
            />}
            <SidebarNode
              type="reviewCartNode"
              label="ReviewCart"
              icon={reviewCartIcon}
              description="Proceed to checkout to complete the purchase."
            />
            <SidebarNode
              type="paymentNode"
              label="Payment"
              icon={paymentIcon}
              description="Make payment for the products subscriber selected."
            />
            {/* <SidebarNode
              type="credentialsNode"
              label="Credentials"
              icon={credentialsIcon}
              description="Set credentials"
            /> */}
            
            {/* Will be use Infuture */}
            
            <SidebarNode
              type="accountSetupNode"
              label="Account Setup"
              icon={accountSetupIcon}
              description="Create a new account by collecting user details and setting credentials."
            />
            
            {/* <SidebarNode
              type="landingPageNode"
              label="Landing Page"
              icon={landingPageIcon}
              description="Welcome visitors with an engaging and attractive site introduction."
            /> */}
            <SidebarNode
              type="orderReceiptNode"
              label="Order Receipt"
              icon={reviewCartIcon}
              description="Confirm it."
            />
            {/* <SidebarNode
              type="gardenwallNode"
              label="Garden wall"
              icon={gardenWallIcon}
              description="Services have been temporarily disconnected due to a past due payment."
            /> */}
            {nodes.length == 0 && (
              <SidebarNode
                type="gardenwallNode"
                label="Garden wall"
                icon={gardenWallIcon}
                description="Services have been temporarily disconnected due to a past due payment."
              />
            )}
            {/* NEM  */}
            {/* <SidebarNode
              type="cardNode"
              label="Card"
              icon={cardIcon}
              description=""
            />
            <SidebarNode
              type="portNode"
              label="Port"
              icon={portIcon}
              description=""
            />
            <SidebarNode
              type="splitterNode"
              label="Splitter"
              icon={splitterIcon}
              description=""
            />
            <SidebarNode
              type="virtualLayerNode"
              label="Virtual layer"
              icon={virtualLayerIcon}
              description=""
            />
            <SidebarNode
              type="siteNode"
              label="Site"
              icon={portIcon}
              description=""
            />
            <SidebarNode
              type="rackNode"
              label="Rack"
              icon={rackIcon}
              description=""
            />
            <SidebarNode
              type="circuitNode"
              label="Circuit"
              icon={cardIcon}
              description=""
            />
            <SidebarNode
              type="deviceNode"
              label="Device"
              icon={portIcon}
              description=""
            /> */}
            {/* <SidebarNode
              type="orderReceiptNode"
              label="Confirmation"
              icon={confirmationIcon}
              description=""
            /> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarTabs;

